export enum WalkingFarmMainTabEnum {
  New = 'new',
  Saved = 'saved'
}

export enum WalkingFarmNewTabEnum {
  Polygon = 'polygon',
  Radius = 'radius'
}

export enum WalkingFarmViewTabEnum {
  Details = 'details',
  List = 'list',
  Map = 'map'
}

export enum WalkingFarmLeadStatusEnum {
  Lead = 'lead',
  NotContacted = 'not contacted',
  NotHome = 'not home',
  NotInterested = 'not interested',
  OnMarket = 'on market',
  Prospect = 'prospect'
}

export enum WalkingFarmLeadStatusLabelEnum {
  Default = 'N/A',
  Lead = 'Lead',
  NotContacted = 'Not Contacted',
  NotHome = 'Not Home',
  NotInterested = 'Not Interested',
  OnMarket = 'On Market',
  Prospect = 'Prospect'
}

export enum WalkingFarmLeadStatusColorEnum {
  Default = '#808080',
  Lead = '#018626',
  NotContacted = '#484c5e',
  NotHome = '#ee3c37',
  NotInterested = '#eead37',
  OnMarket = '#5d45ad',
  Prospect = '#0b67af'
}

export enum WalkingFarmPropertiesSortByEnum {
  LeadStatus = 'leadStatus',
  ParcelNumber = 'parcelNumber',
  StreetName = 'streetName',
  UnreadAlerts = 'unreadAlerts'
}

export enum WalkingFarmPropertiesOwnerStatusFilterEnum {
  All = 'all',
  EmptyNesters = 'emptyNesters',
  NonOwnerOccupied = 'unoccupied',
  OutOfStateOwners = 'outOfState',
  OwnerOccupied = 'occupied',
  YearsInHome = 'yearsInHome'
}

export enum FarmSizeIdentifierEnum {
  L = 'FARM_PROPERTIES_PHONE_AND_EMAILS_L',
  M = 'FARM_PROPERTIES_PHONE_AND_EMAILS_M',
  S = 'FARM_PROPERTIES_PHONE_AND_EMAILS_S'
}

export enum WalkingFarmExportReportEnum {
  Csv = 'csv',
  Duplicate = 'duplicate',
  Labels = 'labels',
  Pdf = 'pdf'
}
